import {createSlice}  from '@reduxjs/toolkit';

const appointmentScheduleSlice = createSlice({
    name: 'appointmentSchedule',
    initialState: { 
        tab: 'lead',
        leadForm: {
            first_name: '',
            last_name: '',
            street: '',
            city: '',
            state: '',
            zipcode: '',
            phone: '',
            email: '',
            connectBy:'' 
        },
        appointmentForm: {
            appointmentDate: "",
            appointmentTime: ""
        },
        appointmentInfo: [],
        outsideParamFlag: false
    },
    reducers: {
        setLeadForm: (state, action) => {
            state.leadForm = action.payload;
        },
        setAppointmentForm: (state, action) => {
            state.appointmentForm = action.payload;
        },
        setTab: (state, action) => {
            state.tab = action.payload;
        },
        setAppointmentInfo: (state, action) => {
            state.appointmentInfo = action.payload;
        },
        setOutsideParamFlag: (state, action) => {
            state.outsideParamFlag = action.payload;
        }
    }
});

export const {setTab, setLeadForm, setAppointmentForm, setAppointmentInfo, setOutsideParamFlag} = appointmentScheduleSlice.actions;
export default appointmentScheduleSlice.reducer;